export default "__VITE_PUBLIC_ASSET__e0378b0f__"